<footer class="CullenFooter">
  <div class="Wrap">
    <div class="Grid">
      <div class="Col Col-left">
        <p class="Text">© {{todayDate | date : 'yyyy'}} | Cullen International SA<span> &ndash; Regulation made simple</span></p>
      </div>
      <div class="Col Col-right">
        <ul class="Links-new">
          <li>
            <a href="https://www.cullen-international.com/privacy.html" target="_blank">Privacy policy</a>
          </li>
          <li>
            <a href="https://www.cullen-international.com/terms.html" target="_blank">Terms and Conditions</a>
          </li>
          <li>
            <a href="https://www.cullen-international.com/contact.html" target="_blank">Contact</a>
          </li>
          <li class="Social Social--twitter">
            <a href="https://twitter.com/CullenInt/" target="secondaryTab">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
                <polygon points="59.6,43.2 96.8,4 87.3,4 55,37.5 29.7,4 -0.4,4 38.9,54.8 0.6,95.1 9.4,95.1 43.5,60.5 70,95.1 100,95.1 "/>
              </svg>
            </a>
          </li>
          <li class="Social Social--linkedin">
            <a href="https://www.linkedin.com/company/cullen-international/" target="secondaryTab">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
                <path d="M33.79,97.81c0-21.85,0-43.51,0-65.28c0.28-0.01,0.57-0.04,0.86-0.04c6.61,0,13.23,0.01,19.84-0.02
                  c0.75,0,0.99,0.19,0.98,0.97c-0.05,2.65-0.02,5.3-0.02,8.21c0.62-0.85,1.09-1.51,1.58-2.15c4.54-5.94,10.65-8.57,18.03-8.52
                  c4.73,0.03,9.22,1,13.3,3.5c4.13,2.53,6.98,6.15,8.86,10.56c2.08,4.9,2.76,10.06,2.77,15.32c0.02,12.2,0.01,24.41,0.01,36.61
                  c0,0.24,0,0.49,0,0.78c-7.25,0-14.43,0-21.72,0c0-0.4,0-0.75,0-1.1c0-11.07,0-22.14,0-33.2c0-2.92-0.21-5.81-1.2-8.58
                  c-1.68-4.71-5.6-7.14-10.59-6.7c-5.46,0.48-8.8,3.59-10.48,8.54c-0.55,1.62-0.52,3.49-0.53,5.25c-0.04,11.59-0.02,23.19-0.02,34.78
                  c0,1.06,0,1.06-1.09,1.06c-6.53,0-13.06,0-19.59,0C34.45,97.81,34.12,97.81,33.79,97.81z"/>
                <path d="M21.7,97.77c-7.27,0-14.4,0-21.62,0c-0.02-0.32-0.06-0.61-0.06-0.9c0-21.16,0-42.32-0.02-63.48
                  c0-0.75,0.23-0.92,0.94-0.92c6.61,0.03,13.22,0.03,19.83,0c0.71,0,0.94,0.16,0.94,0.91c-0.02,21.16-0.02,42.32-0.02,63.48
                  C21.7,97.14,21.7,97.42,21.7,97.77z"/>
                <circle cx="10.6" cy="13.24" r="10.53"/>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>